import React from "react";
import PropTypes from "prop-types";
import RecallBlackIcon from "./recall_black_24dp.svg?react";
import RecallWhiteIcon from "./recall_white_24dp.svg?react";

export default function RecallIcon(props) {
	return <div>{props.white ? <RecallWhiteIcon /> : <RecallBlackIcon />}</div>;
}

RecallIcon.propTypes = {
	white: PropTypes.bool,
};
